import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { getClientsList, selectClientsList } from "../../redux/modules/clients";
import { getMeetingsList, selectMeetingsList, getBrokerToursList, selectBrokerToursList } from "../../redux/modules/meeting";
import { getBookingsList, selectBookingsList } from "../../redux/modules/bookings";
import { getDealsList } from "../../redux/modules/deals";
import Layout from "../layout"
import Loader from "../common/loader"
import Table from "../common/table"

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const mobile = useSelector(state => state.mobile);
  const auth = useSelector(state => state.auth);  
  const clients = useSelector(state => state.clients); 
  const clientslist = useSelector((state) => selectClientsList(state)); 
  const meetings = useSelector(state => state.meeting);
  const meetingslist = useSelector((state) => selectMeetingsList(state));
  const brokertours = useSelector(state => state.meeting.brokertours);
  const brokertourslist = useSelector((state) => selectBrokerToursList(state));
  const bookings = useSelector((state) => state.bookings);
  const bookingslist = useSelector((state) => selectBookingsList(state));
  const deals = useSelector(state => state.deals);
  const dealslist = useSelector(state => state.deals.deals);
  const [active, setActive] = useState(location.state ? parseInt(location.state.hash) : (window.location.hash ? parseInt(window.location.hash.split('#')[1]) : 0));
  const [filter, setFilter] = useState(null);

  useEffect(() => {
      document.title = 'Дашборд | Личный кабинет Брокера THE FIVE';
      
      dispatch(
        getClientsList({
          cmd: 'clients-list',
          _debug_token: auth.token
        })
      )
      dispatch(
        getBookingsList({
          cmd: "deal-bookinglist",
          _debug_token: auth.token
        })
      );
      dispatch(
        getMeetingsList({
          cmd: 'orders-list',
          eventTypeId: 1,
          _debug_token: auth.token
        })
      )
      dispatch(
        getBrokerToursList({
          cmd: 'orders-list',
          eventTypeId: 2,
          _debug_token: auth.token
        })
      )
      dispatch(
        getDealsList({
          cmd: "deal-list",
          _debug_token: auth.token,
        })
      );
    }, []);

  
  const handleClick = (e) => {
    const index = parseInt(e.target.id, 0);
    if (index !== active) {
      setActive(index);
      navigate('#' + index);
    }    
  };
  
  const handleFilter = (e) => {
    const index = parseInt(e.target.id, 0);
    setFilter(index !== filter ? index : null); 
  };

  const filtrated = (data, param) => {

    if(!data) return []

    if(filter === 0) {
      return data.filter((el) =>  el[param].split(" ")[0].split(".").reverse().join("-") === new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().split("T")[0])
    }

    if(filter === 1) {
      return data.filter((el) =>  {
        let tomorrow = new Date(new Date().setDate(new Date().getDate() + 1));
        return el[param].split(" ")[0].split(".").reverse().join("-") === new Date(tomorrow.getTime() - tomorrow.getTimezoneOffset() * 60000).toISOString().split("T")[0]
      })
    }

    if(filter === 2) {
      return data.filter((el) =>  {
        let days = new Date(new Date().setDate(new Date().getDate() + 4));
        //let dayss = new Date(days.getTime() - days.getTimezoneOffset() * 60000).toISOString().split("T")[0]
        //let today = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().split("T")[0]
        //return el[param].split(" ")[0].split(".").reverse().join("-") <= dayss && new Date(el[param]).toISOString().split("T")[0] >= today 
        return el[param].split(" ")[0].split(".").reverse().join("-") === new Date(days.getTime() - days.getTimezoneOffset() * 60000).toISOString().split("T")[0]
      })
    }

    return data
  }

  return (
    <Layout>
      {(clients.loading || bookings.loading || meetings.loading || deals.loading) && <Loader />}
      <div className="dashboard">
        <div className="title-small">Результаты</div>
        <div className="info-block">
          <div className="info-block__item info-block__item_money">
            <div className="info-block__text">Сумма сделок</div>
            <div className="info-block__num">{dealslist && new Intl.NumberFormat("ru-RU").format(Math.round(dealslist.filter((item) => item.status === "Действующий").reduce((sum, item) => { return sum + item.amount}, 0)))} ₽</div>        
          </div>
          <div className="info-block__item info-block__item_purse">
            <div className="info-block__text">Комиссионное вознаграждение</div>
            <div className="info-block__num">{dealslist && new Intl.NumberFormat("ru-RU").format(Math.round(dealslist.filter((item) => item.status === "Действующий").reduce((sum, item) => { return sum + item.commission}, 0)))} ₽</div>        
          </div>
        </div>
        <div className="title-small">Статистика по клиентам</div>
        <div className="info-block info-block_half">
          <div className="info-block__item">
            <div className="info-block__text">Зафиксированные {mobile && <br/>}клиенты</div>
            <div className="info-block__num">{clientslist && clientslist.length}</div>        
          </div>
          <div className="info-block__item">
            <div className="info-block__text">Запланированные {mobile && <br/>}встречи</div>
            <div className="info-block__num">{meetingslist && meetingslist.filter(el => el.status === 'Запланирована').length}</div>        
          </div>
          <div className="info-block__item">
            <div className="info-block__text">Активные {mobile && <br/>}брони</div>
            <div className="info-block__num">{bookingslist && bookingslist.filter(el => el.status === 'Активна').length}</div>        
          </div>
          <div className="info-block__item">
            <div className="info-block__text">Сделки на {mobile && <br/>}подготовке</div>
            <div className="info-block__num">{dealslist && dealslist.filter(el => el.status === 'На подготовке').length}</div>        
          </div>
        </div>
        <div className="title-small">Ближайшие события </div>
        <div className="filters">
          <div className="filters__line">
            <div className="filters__btn" onClick={handleClick} data-active={active === 0} id={0}>Окончание фиксации</div>
            <div className="filters__btn" onClick={handleClick} data-active={active === 1} id={1}>Окончание брони</div>
            <div className="filters__btn" onClick={handleClick} data-active={active === 2} id={2}>Встречи</div>
            <div className="filters__btn" onClick={handleClick} data-active={active === 3} id={3}>Брокер-туры</div>
          </div>
          <div className="filters__line filters__line_small">
            <div className="filters__btn" onClick={handleFilter} data-active={filter === 0} id={0}>Сегодня</div>
            <div className="filters__btn" onClick={handleFilter} data-active={filter === 1} id={1}>Завтра</div>
            <div className="filters__btn" onClick={handleFilter} data-active={filter === 2} id={2}>5 дней</div>
          </div>
        </div>

        <div className="tabs-content" data-active={active === 0} data-id={0}>
          <Table 
            columns={mobile ? (
              auth.user.group === 'lead' ? [
                { label: "Осталось дней", value: "days_left" },
                { label: "Клиент", value: "clientName" },
                {},
                { label: "Телефон", value: "clientPhone" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "Окончание фиксации", value: "dateEnd" },
                { label: "Менеджер", value: "manager" },
                { label: "Брокер", value: "brocker" }
              ] : [
                { label: "Осталось дней", value: "days_left" },
                { label: "Клиент", value: "clientName" },
                {},
                { label: "Телефон", value: "clientPhone" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "Окончание фиксации", value: "dateEnd" },
                { label: "Менеджер", value: "manager" }
              ]
            ) : (
              auth.user.group === 'lead' ? [
                { label: "Дата фиксации", value: "dateStart" },
                { label: "Осталось дней", value: "days_left" },
                { label: "Окончание фиксации", value: "dateEnd" },
                { label: "Клиент", value: "clientName" },
                { label: "Телефон", value: "clientPhone" },
                { label: "Менеджер", value: "manager" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "Брокер", value: "brocker" }
              ] : [
                { label: "Дата фиксации", value: "dateStart" },
                { label: "Осталось дней", value: "days_left" },
                { label: "Окончание фиксации", value: "dateEnd" },
                { label: "Клиент", value: "clientName" },
                { label: "Телефон", value: "clientPhone" },
                { label: "Менеджер", value: "manager" },
                { label: "Проект/Тип объекта", value: "project" },
              ]
            )}
            sortmobile={[
              { label: "Осталось дней", value: "days_left" },
              { label: "Клиент", value: "clientName" },
            ]}
            data={filtrated(clientslist, 'dateEnd')} 
          /> 
        </div>
        <div className="tabs-content" data-active={active === 1} data-id={1}>
          <Table 
            bookingPage={true} 
            columns={mobile ? (
              auth.user.group === "lead" ? [
                { label: "Осталось дней", value: "days_left" },
                { label: "Клиент", value: "clientName" },
                { label: "Окончание брони", value: "dateEnd" },
                { label: "Телефон", value: "clientPhone" },
                { label: "Проект/Тип объекта", value: "projectId" },
                { label: "Объект", value: "object" },
                { label: "Помещение", value: "premise" },
                { label: "Статус", value: "status" },
                { label: "Менеджер", value: "manager" },
                { label: "Брокер", value: "brocker" },
              ] : [
                { label: "Осталось дней", value: "days_left" },
                { label: "Клиент", value: "clientName" },
                { label: "Окончание брони", value: "dateEnd" },
                { label: "Телефон", value: "clientPhone" },
                { label: "Проект/Тип объекта", value: "projectId" },
                { label: "Объект", value: "object" },
                { label: "Помещение", value: "premise" },
                { label: "Статус", value: "status" },
                { label: "Менеджер", value: "manager" },
              ]
            ) : (
              auth.user.group === "lead" ? [
                { label: "Дата брони", value: "dateStart" },
                { label: "Осталось дней", value: "days_left" },
                { label: "Окончание брони", value: "dateEnd" },
                { label: "Клиент", value: "clientName" },
                { label: "Телефон", value: "clientPhone" },
                { label: "Менеджер", value: "manager" },
                { label: "Брокер", value: "brocker" },
                { label: "Проект/Тип объекта", value: "projectId" },
                { label: "Объект", value: "object" },
                { label: "Помещение", value: "premise" },
                { label: "Статус", value: "status" },
              ] : [
                { label: "Дата брони", value: "dateStart" },
                { label: "Осталось дней", value: "days_left" },
                { label: "Окончание брони", value: "dateEnd" },
                { label: "Клиент", value: "clientName" },
                { label: "Телефон", value: "clientPhone" },
                { label: "Менеджер", value: "manager" },
                { label: "Проект/Тип объекта", value: "projectId" },
                { label: "Объект", value: "object" },
                { label: "Помещение", value: "premise" },
                { label: "Статус", value: "status" },
              ]
            )} 
            sortmobile={[
              { label: "Осталось дней", value: "days_left" },
              { label: "Клиент", value: "clientName" },
            ]} 
            data={filtrated(bookingslist && bookingslist.filter((item) => item.status === 'Активна'), 'dateEnd')} 
          />
        </div>
        <div className="tabs-content" data-active={active === 2} data-id={2}>
          <Table 
            columns={mobile ? (
              auth.user.group === "lead" ? [
                { label: "Дата и время", value: "timeslot" },
                { label: "Клиент", value: "clientName" },
                { label: "", value: "action" },
                { label: "Телефон", value: "clientPhone" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "Менеджер", value: "manager" },
                { label: "Статус", value: "status" },
                { label: "Формат встречи", value: "formatId" },
                { label: "Брокер", value: "brocker" },
              ] : [
                { label: "Дата и время", value: "timeslot" },
                { label: "Клиент", value: "clientName" },
                { label: "", value: "action" },
                { label: "Телефон", value: "clientPhone" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "Менеджер", value: "manager" },
                { label: "Статус", value: "status" },
                { label: "Формат встречи", value: "formatId" },
              ]
            ) : (
              auth.user.group === "lead" ? [
                { label: "Дата и время", value: "timeslot" },
                { label: "Клиент", value: "clientName" },
                { label: "Телефон", value: "clientPhone" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "Менеджер", value: "manager" },
                { label: "Статус", value: "status" },
                { label: "Формат встречи", value: "formatId" },
                { label: "Брокер", value: "brocker" },
                { label: "Действия", value: "action" },
              ] : [
                { label: "Дата и время", value: "timeslot" },
                { label: "Клиент", value: "clientName" },
                { label: "Телефон", value: "clientPhone" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "Менеджер", value: "manager" },
                { label: "Статус", value: "status" },
                { label: "Формат встречи", value: "formatId" },
                { label: "Действия", value: "action" },
              ]
            )}
            sortmobile={[
              { label: "Дата/время", value: "timeslot" },
              { label: "Клиент", value: "clientName" },
            ]}
            eventTypeId={1}
            data={filtrated(meetingslist && meetingslist.filter((item) => item.status === 'Запланирована'), 'timeslot')} 
          />
        </div>
        <div className="tabs-content" data-active={active === 3} data-id={3}>
          <Table 
            columns={mobile ? (
              auth.user.group === "lead" ? [
                { label: "Дата и время", value: "timeslot" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "", value: "action" },
                { label: "Формат брокер-тура", value: "formatId" },
                { label: "Менеджер", value: "manager" },
                { label: "Статус", value: "status" },
                { label: "Брокер", value: "brocker" },
              ] : [
                { label: "Дата и время", value: "timeslot" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "", value: "action" },
                { label: "Формат брокер-тура", value: "formatId" },
                { label: "Менеджер", value: "manager" },
                { label: "Статус", value: "status" },
              ]
            ) : (
              auth.user.group === "lead" ? [
                { label: "Дата и время", value: "timeslot" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "Менеджер", value: "manager" },
                { label: "Статус", value: "status" },
                { label: "Формат брокер-тура", value: "formatId" },
                { label: "Брокер", value: "brocker" },
                { label: "Действия", value: "action" },
              ] : [
                { label: "Дата и время", value: "timeslot" },
                { label: "Проект/Тип объекта", value: "project" },
                { label: "Менеджер", value: "manager" },
                { label: "Статус", value: "status" },
                { label: "Формат брокер-тура", value: "formatId" },
                { label: "Действия", value: "action" },
              ]
            )}
            sortmobile={[
              { label: "Дата/время", value: "timeslot" },
              { label: "Проект", value: "project" },
            ]}
            eventTypeId={2}
            data={filtrated(brokertourslist && brokertourslist.filter((item) => item.status === 'Запланирован'), 'timeslot')} 
          />
        </div>
      </div>
    </Layout>
  )
}

export default Dashboard